import CardDefault from "components/Cards/CardDefault";
import { Flex, Divider } from "@chakra-ui/react";
import DescricaoConta from "./../DescricaoConta/index";
import ContentTags from "./../ContentTags/index";
import history from "infra/helpers/history";
import { ExecucaoOrcamentaria } from "core/features/execucao-orcamentaria/typings/index";

interface ItemExecucaoOrcamentariaProps {
  item: ExecucaoOrcamentaria;
}

export default function ItemExecucaoOrcamentaria({
  item,
}: ItemExecucaoOrcamentariaProps) {
  return (
    <CardDefault
      mb={6}
      py={4}
      onClick={() =>
        history.push(`/financeiro/execucao-orcamentaria/${item.id}`)
      }
    >
      <Flex flexDir="column">
        <Flex>
          <Flex w="100%">
            <DescricaoConta item={item} />
          </Flex>
        </Flex>
        {item.valorArrecadacao ? (
          <>
            <Divider my={4} />
            <ContentTags item={item} />
          </>
        ) : null}
      </Flex>
    </CardDefault>
  );
}
